import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { CancelShipmentReasonTranslationEntity } from './CancelShipmentReasonTranslationEntity'

export class CancelShipmentReasonEntity {
  id?: number
  role?: RoleType
  translations?: Array<CancelShipmentReasonTranslationEntity> | null
}
